import axios from 'axios'

// const payAmountStripe = async (body) => {
//     const { data } = await axios.post('auctionpay/payAmountStripe', body)
//     try {
//         if (data.success) {
//             return data
//         } else {
//             return 'Something went wrong'
//         }
//     } catch (err) {
//         console.log('payAmountStripe====>', err)
//         return 'Something went wrong'
//     }
// }

const payAmountStripe = async (body) => {
    const token = localStorage.getItem('userToken')
    let userData = JSON.parse(localStorage.getItem('userData'))
    const cust_id = userData.card_paymentid
    if (body.payDirect === 1) {
        const data_res = await axios.post(
            'https://paymentapi.auctionsoftware.com/api/charge/create',
            body,
        )
        try {
            if (data_res.data.status == 'success') {
                return data_res
            } else {
                return 'Something went wrong'
            }
        } catch (err) {
            console.log('payAmountStripe====>', err)
            return 'Something went wrong'
        }
    } else {
        if (cust_id != '' && cust_id != undefined) {
            body.card_token = true
            body.customer_id = cust_id
            const data_res = await axios.post(
                'https://paymentapi.auctionsoftware.com/api/customer/source/create',
                body,
            )
            try {
                if (data_res.data.status == 'success') {
                    return data_res
                } else {
                    return { data: { status: 'failed', message: data_res.data.data.message } }
                    // return 'Something went wrong'
                }
            } catch (err) {
                console.log('payAmountStripe====>', err)
                return 'Something went wrong'
            }
        } else {
            const { data } = await axios.post(
                'https://paymentapi.auctionsoftware.com/api/customer/create',
                body,
            )
            try {
                if (data.status == 'success') {
                    body.customer_id = data.data.responseData.id
                    let userData = JSON.parse(localStorage.getItem('userData'))
                    userData.card_paymentid = data.data.responseData.id
                    localStorage.setItem('userData', JSON.stringify(userData))
                    const url =
                        window.location.href.includes('localhost') ||
                        window.location.href.includes('192.168.20.104')
                            ? 'http://192.168.20.104:2001/auctionpay/save_customer_id'
                            : 'https://forwardapidev.auctionsoftware.com/auctionpay/save_customer_id'
                    const { data_res } = await axios.post(url, body, {
                        headers: {
                            Authorization: 'Bearer ' + token,
                        },
                    })
                } else {
                    return 'Something went wrong'
                }
            } catch (err) {
                console.log('payAmountStripe====>', err)
                return 'Something went wrong'
            }
        }
    }
}

export default payAmountStripe
